/**
 * デジタルサイネージ用モジュール
 *
 * @module app/signage/display/SignageDisasterPreventionStatusPage
 */
define(['module',
        'dojo',
        'dojo/_base/array',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/dom-class',
        'dojo/dom-construct',
        'dojo/dom-style',
        'dojo/text!./templates/SignageDisasterPreventionStatusPage.html',
        'idis/service/Requester',
        'idis/view/Loader',
        '../_SignageBase',
        //'../../config',
        'dojo/topic',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
], function(module, dojo, array, declare, lang, domClass, domConstruct, domStyle, template, Requester, Loader, _SignageBase, topic) {

        // 前回表示データ
        // セッションストレージ等に保持するほうが良いか？
        var prevItemStore = {};

        /**
         *
         * @class SignageDisasterPreventionStatusPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageBase,
        /** @lends module:app/signage/display/SignageDisasterPreventionStatusPage~SignageDisasterPreventionStatusPage# */
        {
            // テンプレート文字列
            templateString: template,

            _timer: null,

            // 表示ページ
            _page: 0,

            // ページあたり表示件数
            PAGE_LIST_SIZE: 6,

            // ページ切替間隔時間（秒）
            SIGNAGE_UPDATE_INTERVAL: 10,

            // 値を表示する項目のリスト
            target: [
                {'item':'prefDisasterOccurEvacHouseholdNum', 'area':'prefDisasterOccurEvacHouseholdNumArea'},
                {'item':'prefDisasterOccurEvaqueeNum', 'area':'prefDisasterOccurEvaqueeNumArea'},
                {'item':'prefInstructionEvacHouseholdNum', 'area':'prefInstructionEvacHouseholdNumArea'},
                {'item':'prefInstructionEvaqueeNum', 'area':'prefInstructionEvaqueeNumArea'},
                {'item':'prefPreparationEvacHouseholdNum', 'area':'prefPreparationEvacHouseholdNumArea'},
                {'item':'prefPreparationEvaqueeNum', 'area':'prefPreparationEvaqueeNumArea'},
                {'item':'prefOpeningShelterMunicNum', 'area':'prefOpeningShelterMunicNumArea'},
                {'item':'prefOpeningShelterNum', 'area':'prefOpeningShelterNumArea'},
                {'item':'prefEvacHouseholdNum', 'area':'prefEvacHouseholdNumArea'},
                {'item':'prefEvaqueeNum', 'area':'prefEvaqueeNumArea'},
                {'item':'totalDamageNum', 'area':'totalDamageNumArea'},
                {'item':'sedDamageNum', 'area':'sedDamageNumArea'},
                {'item':'houseDamageNum', 'area':'houseDamageNumArea'},
                {'item':'riverDamageNum', 'area':'riverDamageNumArea'},
                {'item':'deadNum', 'area':'deadNumArea'},
                {'item':'unknownNum', 'area':'unknownNumArea'},
                {'item':'seriousNum', 'area':'seriousNumArea'},
                {'item':'mildNum', 'area':'mildNumArea'},
            ],

            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',

            constructor: function() {
                this.inherited(arguments);
            },

            buildRendering: function() {
                this.inherited(arguments);
            },

            startup: function() {
                this.inherited(arguments);
                this.initPage();
            },

            destroy: function() {
                this.inherited(arguments);
                clearTimeout(this._timer);
            },

            /**
             * 画面表示
             */
            initPage: function() {
                this.setDisasterPrevStatusInfo();
            },

            /**
             * 災害対応状況を設定します
             */
            setDisasterPrevStatusInfo: function() {
                var promise = Requester.get('/data/signage/' + this._screenId +'.json', {
                    headers: {'Content-Type': 'application/json; charset=utf-8'},
                    handleAs: 'json',
                    preventCache : true
                }).then(lang.hitch(this, function (item) {
                    // 概況情報を設定
                    var disasterPreventionOverview = item.items.filter(function(element) {
                        return element.disasterName !== null;
                    });
                    var disasterName = disasterPreventionOverview[0]?.disasterName ?? "";
                    topic.publish('app/control/SignageControl::setSignageHeaderDisasterName', disasterName);
                    this.setDisasterPreventionOverview(this, disasterPreventionOverview);

                    // 本部設置状況一覧を設定
                    var disasterPreventionList = item.items.filter(function(element) {
                        return element.disasterName === null;
                    });
                    this.setDisasterPreventionList(this, disasterPreventionList);
                    // 前回データを更新
                    prevItemStore[this._screenId] = item;

                }), function (error) {
                    if (error.response.status === 404) {
                        var disasterPreventionOverview = {};
                        this.setDisasterPreventionOverview(this, disasterPreventionOverview);
                        var disasterPreventionList = [];
                        this.setDisasterPreventionList(this, disasterPreventionList);
                    } else {
                        this.chain.info('情報の取得に失敗しました。', 'エラー');
                    }
                });
                //ローダーの表示
                Loader.wait(promise);
            },

            /**
             * 概況情報を設定します
             */
            setDisasterPreventionOverview: function(self, item) {
                // 項目に取得した値を設定
                array.forEach(this.target, function(target){
                    self[target.item].innerHTML = item[0][target.item].toLocaleString() ;
                });

                // 集計エリアのタイトルを設定
                var areaTitleStr = '県内合計';
                if (item[0].municipalityName !== null) {
                    areaTitleStr = '市内合計';
                }
                self.evacOrderAreaTitle.innerHTML =  areaTitleStr;
                self.shelterAreaTitle.innerHTML =  areaTitleStr;
                self.damageAreaTitle.innerHTML =  areaTitleStr;

                // 0世帯＆0人の場合の背景色・文字色変更
                if (item[0].prefDisasterOccurEvacHouseholdNum === 0 && item[0].prefDisasterOccurEvaqueeNum === 0) {
                    domClass.remove(this.prefDisasterOccurArea, 'occur');
                    domClass.add(this.prefDisasterOccurArea, 'none-bg-white');
                } 
                if (item[0].prefInstructionEvacHouseholdNum === 0 && item[0].prefInstructionEvaqueeNum === 0) {
                    domClass.remove(this.prefInstructionArea, 'order');
                    domClass.add(this.prefInstructionArea, 'none-bg-white');
                } 
                if (item[0].prefPreparationEvacHouseholdNum === 0 && item[0].prefPreparationEvaqueeNum === 0) {
                    domClass.remove(this.prefPreparationArea, 'prepare');
                    domClass.add(this.prefPreparationArea, 'none-bg-white');
                } 

                // 更新状態を設定
                this.setDisasterPreventionOverviewUpdate(self, item);
            },

            /**
             * 概況情報の更新状態を設定します
             */
            setDisasterPreventionOverviewUpdate: function(self, item) {
                var updateFlg = false;
                // 前回データがある場合のみ処理
                // 前回データがない場合（≒初回表示）は処理しない
                var prevItem = prevItemStore[this._screenId];
                if (!prevItem) {
                    return;
                }
                var disasterPreventionOverview = prevItem.items[0];
                if (disasterPreventionOverview) {
                    array.forEach(this.target, function(target){
                        // 更新された項目にstyleを設定
                        if (disasterPreventionOverview[target.item] !== item[0][target.item]) {
                            domClass.add(self[target.area], 'update-column');
                            updateFlg = true;
                        } else {
                            domClass.remove(self[target.area], 'update-column');
                        }
                    });
                }
                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }
            },

            /**
             * 本部設置状況一覧を設定します
             */
            setDisasterPreventionList: function(self, data) {
                // 表示をクリア
                var disasterPreventionStatusTBody = dojo.byId('disasterPreventionStatusTBody');
                domConstruct.empty(disasterPreventionStatusTBody);

                // 表示対象ページの抽出
                var firstIndex = this.PAGE_LIST_SIZE * this._page;
                var lastIndex = this.PAGE_LIST_SIZE * (this._page + 1) - 1;
                var displayData = data.filter((element, index) =>
                    index >= firstIndex && index <= lastIndex
                );

                // 画面上のページ数表示
                if (data.length <= this.PAGE_LIST_SIZE) {
                    domStyle.set(this.pageArea, 'display', 'none');
                } else {
                    self.currentPage.innerHTML = this._page + 1;
                    self.totalPage.innerHTML = Math.ceil(data.length / this.PAGE_LIST_SIZE);    
                }

                var prevItem = prevItemStore[this._screenId];
                var disasterPreventionStatus = [];
                if (prevItem) {
                    disasterPreventionStatus = prevItem.items.filter(function(element) {
                        return element.statusName !== null;
                    });
                }
                var updateFlg = false;

                array.forEach(displayData, function(item){
                    // 本部設置状況の前回値
                    var disasterPreventionStatusPrevItem = null;
                    if (disasterPreventionStatus) {
                        disasterPreventionStatusPrevItem = disasterPreventionStatus.filter((element) =>
                            element.municipalityName === item.municipalityName
                        )[0];
                    }

                    var className = '';
                    var tr = domConstruct.create('tr');

                    // 市町村
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: item.municipalityName, class: 'align-middle text-center fw-bold first-col'}), tr);

                    // 体制名称
                    className = disasterPreventionStatusPrevItem && (disasterPreventionStatusPrevItem.statusName !== item.statusName) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span class="mx-2">' + item.statusName, class: className}), tr);

                    // 本部設置状況
                    // 本部設置/解散日時
                    var setStatus = '';
                    var addStyle = '';
                    var timeStamp = '-';
                    switch (item.setFlg) {
                        case '1':
                            setStatus = '<br> 設置';
                            addStyle = 'status-onSet';
                            timeStamp = item.setTimestamp + setStatus;
                            break;
                        case '2':
                            setStatus = '<br> 解散';
                            addStyle = 'status-offSet';
                            timeStamp = item.abolishedTimestamp + setStatus;
                            break;
                    }

                    className = disasterPreventionStatusPrevItem && ((disasterPreventionStatusPrevItem.setTimestamp !== item.setTimestamp) || (disasterPreventionStatusPrevItem.abolishedTimestamp !== item.abolishedTimestamp)) ? 'update-column' : '';
                    if (className)  { updateFlg = true; };
                    className = className + addStyle + ' align-middle text-center';
                    domConstruct.place(domConstruct.create('td', {
                        innerHTML: '<span>' + timeStamp + '</span>', class: className}), tr);

                    domConstruct.place(tr, disasterPreventionStatusTBody);
                });

                // 次回表示ページ
                if (lastIndex >= data.length - 1) {
                    // 先頭ページ
                    this._page = 0;
                } else {
                    // 次ページ
                    this._page += 1;
                }  

                // 更新された項目がある場合、通知音を鳴らす
                if (updateFlg) {
                    this.playAudio();
                }

                // 定期更新処理
                this._timer = setTimeout(lang.hitch(this, function() {
                    self.setDisasterPrevStatusInfo(self, data);
                }), this.SIGNAGE_UPDATE_INTERVAL * 1000);
            }
        });
    });
